import React from 'react';
import { View } from 'react-native';
import { calendarDayColors } from '../Calendar/utils';
import { colors } from '../../../utils/theme';

export type ActivityIndicatorOwnProps = {
    isTargetMonth: boolean;
};

export type ActivityIndicatorProps = ActivityIndicatorOwnProps;

const ActivityIndicator: React.FC<ActivityIndicatorProps> = (props) => {
    return (
        <View
            style={{
                width: 6,
                height: 6,
                borderRadius: 3,
                borderColor: props.isTargetMonth
                    ? colors[calendarDayColors.targetMonth]
                    : colors[calendarDayColors.nonTargetMonth],
                borderWidth: 1,
            }}
        />
    );
};

export default React.memo(ActivityIndicator);
